import script from "./OldSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./OldSummary.vue?vue&type=script&setup=true&lang=ts"

import "./OldSummary.vue?vue&type=style&index=0&id=64b94cde&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64b94cde"]])

export default __exports__